@if (!hideHeader) {
  <ng-casto-header></ng-casto-header>
}
@if (enableErrorPanel === true) {
  <lib-error-panel position="bottom-left"></lib-error-panel>
}
<router-outlet></router-outlet>
<ng-casto-modals></ng-casto-modals>
